import { toast } from "sonner";

interface CustomToastProps {
  id: string | number;
  variant: "success" | "error" | "warning";
  title: string;
  description?: string;
}

const variantStyles = {
  success: {
    bg: "bg-[#C8E6C9]",
    stripe: "bg-[#439446]",
    icon: "check_circle",
    iconClass: "text-success-300",
    titleClass: "text-[#224A23]",
    descriptionClass: "text-[rgba(34,74,35,0.5)]",
    closeClass: "text-success-300",
  },
  error: {
    bg: "bg-[#FFCDD2]",
    stripe: "bg-[#E60017]",
    icon: "error",
    iconClass: "text-error-200",
    titleClass: "text-[#9A3943]",
    descriptionClass: "text-[rgba(154,57,67,0.5)]",
    closeClass: "text-error-200",
  },
  warning: {
    bg: "bg-[#FDF0DC]",
    stripe: "bg-warning-200",
    icon: "warning",
    iconClass: "text-warning-300",
    titleClass: "text-warning-300",
    descriptionClass: "text-warning-300/50",
    closeClass: "text-warning-300",
  },
};

export const CustomToast = (props: CustomToastProps) => {
  const { id, variant, title, description } = props;
  // eslint-disable-next-line security/detect-object-injection -- variant is a typed union literal, not user input
  const styles = variantStyles[variant];
  const displayDescription =
    variant === "error"
      ? (description ??
        "Unable to complete the selected action. Retry the action and contact the support team if the problem persists.")
      : description;

  return (
    <div
      className={`flex w-max max-w-[510px] overflow-hidden rounded-l-[8px] rounded-r-[20px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] ${styles.bg}`}
    >
      <div className={`w-2 shrink-0 ${styles.stripe}`} />
      <div className="flex min-w-0 flex-1 items-center gap-3 p-4">
        <span
          className={`material-symbols-outlined shrink-0 text-base leading-none ${styles.iconClass}`}
        >
          {styles.icon}
        </span>
        <div className="flex min-w-0 flex-col gap-1 px-2">
          <span className={`text-sm font-semibold ${styles.titleClass}`}>
            {title}
          </span>
          {displayDescription && (
            <p className={`text-sm font-medium ${styles.descriptionClass}`}>
              {displayDescription}
            </p>
          )}
        </div>
      </div>
      {variant !== "success" && (
        <button
          onClick={() => toast.dismiss(id)}
          className="flex shrink-0 items-center pr-9 pl-5"
          aria-label="Close"
        >
          <span
            className={`material-symbols-outlined text-base leading-none ${styles.closeClass}`}
          >
            close
          </span>
        </button>
      )}
    </div>
  );
};
